import React, { useContext, useEffect, useRef, useState } from 'react'
import { Context } from '../Context/Context'
import close from '../Components/Images/x-close.png';

const DeleteProfile = ({ setDeleteBenBar, setDeleteErrorBar }) => {
    const { deleteProfile, handleDeleteProfile, setDeleteProfile, setViewDetails, fetchBeneficiaries } = useContext(Context)
    const DeleteModel = useRef()

    const [BenficairyDetails, setBenficairyDetails] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false);

    const closeRef = (e) => {
        if (DeleteModel.current === e.target) {
            handleDeleteProfile()
        }
    }

    const deleteABeneficairy = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)
        const token = localStorage.getItem('token');
        const BeneficairyID = localStorage.getItem('BeneficairyID');

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary/${BeneficairyID}`, {
            method: "DELETE",
            headers: {
                Authorization: `Token ${token}`,
                "Content-Type": "application/json",
            },
        });

        let data = {};
        try {
            const text = await response.text();
            data = text ? JSON.parse(text) : {};

            if (!response.ok) {
                setDeleteErrorBar(true)
                throw new Error(data.message || 'Failed');
            } else {
                console.log('Beneficiary deleted:', data);
                window.scrollTo(0, 0);
                setDeleteProfile(false)
                setDeleteBenBar(true);
                setViewDetails(false)
                fetchBeneficiaries()
                console.log('Modal opened:', DeleteModel);
            }
        } catch (err) {
            console.warn('No JSON response or invalid JSON:', err);
            setDeleteErrorBar(true)
        } finally {
            setIsSubmitting(false)
        }
    };

    useEffect(() => {

        if (!deleteProfile) return;

        const token = localStorage.getItem('token');
        const BeneficairyID = localStorage.getItem('BeneficairyID');

        const fetchBenficairy = async () => {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary/${BeneficairyID}`, {
                method: "GET",
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            const data = await res.json();
            setBenficairyDetails(data);
        };

        fetchBenficairy();
    }, [deleteProfile]);


    return (
        <div onClick={closeRef} ref={DeleteModel} className={`fixed flex items-center justify-center z-50 inset-0 bg-opacity-30 bg-black/40 ${deleteProfile ? 'block' : 'hidden'}`}>
            <div className='bg-white w-[470px] 2xl:w-[25%] shadow-lg rounded-xl flex flex-col justify-center mx-3 py-5 px-7'>
                <div className='flex justify-between gap-3'>
                    <div>
                        <p className='text-[18px] text-[#1D1C1F] font-medium mb-2'>Delete information?</p>
                        <p className='text-[#525154] font-normal text-[14px]'>This will permanently delete {BenficairyDetails?.full_name} from your client list.</p>
                        <p className='text-[#525154] font-normal text-[14px] mt-2'>(<strong>Note:</strong> You cannot delete an account if a transfer has been made to them)</p>
                    </div>
                    <img
                        className='size-5 mt-1 cursor-pointer' src={close} alt=""
                        onClick={handleDeleteProfile}
                    />
                </div>
                <div className='flex justify-end gap-2 mt-12'>
                    <button
                        className='p-3 rounded-lg w-[30%] border-[1.2px] text-[#525154] text-[14px] border-black/10'
                        onClick={handleDeleteProfile}
                    >
                        Cancel
                    </button>
                    <button
                        className='p-3 rounded-lg font-medium bg-[#FEEDED] text-[#EF4444] text-[14px] w-[30%]'
                        onClick={deleteABeneficairy}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            'Deleting...'
                        ) : (
                            'Delete'
                        )}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeleteProfile